module.exports = __webpack_public_path__ + "static/media/ZW.2ab6c037.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/ZW.svg
// module id = 397
// module chunks = 0